import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }

import Card from '@/components/layout/Card.vue';
import BackLinkTitle from '@/components/layout/BackLinkTitle.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import ActivityForm from '@/components/activities/ActivityForm.vue';
import {useI18n} from "vue3-i18n";
import {computed} from "vue";
import {Guid} from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminActivityForm',
  props: {
    id: {}
  },
  setup(__props: any) {

const {t} = useI18n()

// eslint-disable-next-line no-undef
const props = __props

const isEditMode = computed(() => props.id && Guid.isValid(props.id));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.activities.${!isEditMode.value ? 'add' : 'update'}.name`)
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)(`routes.admin.children.activities.${!isEditMode.value ? 'add' : 'update'}.name`)
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(ActivityForm, {
          id: props.id
        }, null, 8, ["id"])
      ]),
      _: 1
    })
  ]))
}
}

})